<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card">
        <div class="card-header">
           <h5 class="alert-heading font-18 text-dark" style="font-weight: 400;">Cpv ցանկ</h5>
        </div>
        <div class="card-body">
          <div v-if="loaded">
            <div class="tab-content">
              <div class="tab-panel" :class="{'active': organizeType === 0}" id="settings-1" role="tabpanel">
                <div class="row">
                  <div class="col-12">
                    <StateCategory :selectedCpvs.sync="selectedCpvs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else>
            <div class="m-3 spinner-border spinner-border-xl text-primary" role="status"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card" v-for="(item,index) in selectedCpvs" :key="index">
        <div class="card-header">
          <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" :data-target="`#openCpv${index}`" aria-expanded="false" :aria-controls="`openCpv${index}`">
            <i v-if="open" class="fas fa-angle-up"></i>
            <i v-else class="fas fa-angle-down"></i>
            <h5 :data-target="`#openCpv${index}`" aria-expanded="false" :aria-controls="`openCpv${index}`" class="btn alert-heading font-18 text-dark">{{item.name}} - {{item.code}}</h5>
          </button>
        </div>
        <div :id="`openCpv${index}`" class="collapse multi-collapse" style="padding: 0.75rem 1.25rem;">
          <div class="d-flex flex-column">
            <div>Տեխնիկական բնութագրեր</div>
            <div>
              test
              <!-- <multiselect
                v-model="selected"
                selectLabel="Սեղմեք enter ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                :close-on-select="false"
                :allowEmpty="true"
                :searchable="true"
                :multiple="true"
                placeholder="Ընտրեք տեխնիկական բնութագրերը"
                track-by="id"
                label="name"
                :options="test"
              >
                {{test}}
              </multiselect> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StateCategory from "./categoryForm/StateCategory";

  export default {
    components: { StateCategory },
    name: 'selectCategory',
    data() {
      return {
        selected: [],
        organizeType: 0,
        selectedCpvs: [],
        selectedCategories: [],
        update: false,
        loaded: false,
        open: false,
        test: ['a', 'b', 'c', 'd', 'e', 'f'],
      }
    },
    async mounted() {
      await this.$client.get('user-cpvs').then(({data}) => {
        if(data.data.length){
          this.selectedCpvs = [...data.data]
          this.update = true;
        } else if(this.$route.path !== '/settings') {
          this.$fire({
            title: "Զգուշացում",
            text: "Խնդրում ենք ընտրել կատեգորիա շարունակելու համար",
            type: "warning",
            confirmButtonText: 'Լավ'
          })
        }
        this.$client.get('user-categories').then(({data}) => {
          if(data.data){
            this.selectedCategories = [...data.data]
          }
        })
      })
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
      this.$store.dispatch('procurement/getPlans')
    
      this.test.forEach((item, index) => {
        this.$set(item, index)
      })
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
    methods: {
      handleClick() {
        if (!this.selectedCpvs.length && !this.selectedCategories.length) {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ընտրեք գոնե մեկ կատեգորիա շարունակելու համար'
          })
        } else {
          this.$client.post(`user-cpvs/${this.me.id}`, this.selectedCpvs).then(({data}) => {
            if(data.status){
              this.$client.post(`user-categories/${this.me.id}`, this.selectedCategories).then(({data}) => {
                console.log(data)
                if(data.status){
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ պահպանված է'
                  })
                  console.log('here')
                  this.$client.put(`user`, { first_login: 0 }).then(({data}) => {
                    if(data){
                      this.$store.dispatch('firstLogin', 0).then(() => {
                        this.$router.push({ path: '/participant/tenders' })
                      })
                    }
                  }).catch(e => {
                    this.$notify({
                      group: 'foo',
                      type: 'error',
                      title: 'Ինչ որ բան այն չէ',
                      text: 'Կրկին փորձեք!'
                    })
                  })
                }
              }).catch(e => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: 'Ինչ որ բան այն չէ',
                  text: 'Կրկին փորձեք!'
                })
              })
            }
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        }
      },
    },
  }
</script>
<style scoped>
  .card-header{
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }
</style>
